const Preferences = () => {
  return <> Preference Settings</>;
};

export default Preferences;
